<template>
    <div v-bind="$attrs" class="zs-form form">
        <slot></slot>
    </div>
</template>

<script setup>
import { ref, provide, onMounted, nextTick } from 'vue';
import Validator from '@/utils/Validator';

const props = defineProps({
    rules: {
        type: Array,
        default: () => []
    },
    language:{
        type:String,
        default:'pt'
    },
    validateOnSubmit: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['validate']);

const validator = ref(new Validator(props.language));

import { watch } from 'vue';

watch(() => props.language, (newLang) => {
    validator.value.setLanguage(newLang);
});

provide('validator', validator.value);

const validateForm = (immediate = false) => {
    if (immediate) {
        validator.value.validateAll();
        emit('validate', validator.value.getErrors());
        return validator.value.getErrors();
    }

    nextTick(() => {
        validator.value.validateAll();
        emit('validate', validator.value.getErrors());
    });
};

const resetForm = (imediate = false) => {
    if(imediate){
        validator.value.reset();
        return;
    }
    nextTick(() => {
        validator.value.reset();
    });
};

onMounted(() => {
    validator.value.setRules(props.rules);
});

// Expose methods to parent components
defineExpose({
    validateForm,
    resetForm,
    validator: validator.value
});
</script>

<style>
.form-field-info{
    margin-top: 1em;
}
</style>